import { KeyInput } from "appworks/utils/key-input";
import { KeyboardCode } from "appworks/utils/keyboard";
import { SignalBinding } from "signals";

export class ReelsetControlDebugger {
    protected containerEl: HTMLDivElement;
    protected selectReelsetEl: HTMLSelectElement;
    protected reelstopsEl: HTMLInputElement;
    protected reelsLandedBinding: SignalBinding;

    constructor() {
        const keyInput = new KeyInput();
        keyInput.onKeyUp.add((key: string, e: KeyboardEvent) => {
            if (e.shiftKey) {
                if (key === KeyboardCode.R) {
                    this.toggle();
                }
            }
        });
    }

    public start() {
        this.draw();
    }

    public toggle() {
        //
    }

    protected draw() {
        //
    }

    protected updateReelstops() {
        //
    }
}
